import React from 'react';
import { Search, Calculator, Home, Building2, Map, Star } from 'lucide-react';
const TRUST_CARDS = [{
  icon: Search,
  title: 'Model identification help',
  desc: 'Send photos of an existing mailbox, part, or sign system so the team can help identify the manufacturer, model, or closest available match.'
}, {
  icon: Calculator,
  title: 'Free diagnostic & estimating',
  desc: 'Get help with replacement options, project scope, pricing, lead times, and what information is needed before ordering.'
}, {
  icon: Home,
  title: 'HOA and community matching',
  desc: 'Helpful for homeowners and communities trying to match an existing approved mailbox, finish, post, plaque, or street theme.'
}, {
  icon: Building2,
  title: 'Commercial project planning',
  desc: 'Support for CBUs, 4C systems, parcel lockers, door counts, numbering, replacement parts, and development planning.'
}, {
  icon: Map,
  title: 'Postal requirement awareness',
  desc: 'USPS and project requirements can vary by product and installation type. MidAtlantic helps customers know what to confirm before placing commercial orders.'
}, {
  icon: Star,
  title: 'Top-rated manufacturers',
  desc: 'A curated catalog of residential, commercial, streetscape, signage, lighting, and exterior products from established manufacturers.'
}];
export function ReviewsTrust() {
  return <section className="py-16 lg:py-24 bg-brand-goldWash border-t border-brand-border" data-id="element-444">
      <div className="max-w-7xl mx-auto px-4" data-id="element-445">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-446">
          <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs mb-2 block flex items-center justify-center gap-2" data-id="element-447">
            <span className="w-8 h-px bg-brand-gold" data-id="element-448"></span>
            Why buyers trust MidAtlantic
            <span className="w-8 h-px bg-brand-gold" data-id="element-449"></span>
          </span>
          <h2 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-450">
            Guidance for the details that are easy to get wrong
          </h2>
          <p className="text-lg text-brand-muted" data-id="element-451">
            Whether you are matching an HOA mailbox, replacing a damaged part,
            planning a commercial delivery setup, or confirming installation
            requirements, MidAtlantic helps turn a confusing catalog into a
            clearer buying decision.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-452">
          {TRUST_CARDS.map((card, idx) => {
          const Icon = card.icon;
          return <div key={idx} className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-start gap-4 hover:border-brand-maroon/60 transition-colors" data-id="element-453">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft border border-brand-gold/30 flex items-center justify-center text-brand-maroon shadow-sm" data-id="element-454">
                  <Icon size={24} strokeWidth={1.5} data-id="element-455" />
                </div>
                <div data-id="element-456">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-2" data-id="element-457">
                    {card.title}
                  </h3>
                  <p className="text-sm text-brand-muted leading-relaxed" data-id="element-458">
                    {card.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-12 text-center" data-id="element-459">
          <p className="text-sm font-medium text-brand-charcoal bg-brand-goldSoft inline-block px-6 py-3 rounded-full border border-brand-gold/30" data-id="element-460">
            Mailbox questions can get specific fast. MidAtlantic helps
            homeowners, HOAs, property managers, and communities choose with
            more confidence.
          </p>
        </div>
      </div>
    </section>;
}